import { render, staticRenderFns } from "./CorrectionTable.vue?vue&type=template&id=46b04463&"
import script from "./CorrectionTable.vue?vue&type=script&lang=js&"
export * from "./CorrectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports